import { GetNotificationsByRecipientAccountId } from '@/http/Notifications/Notification';
import { useQuery } from '@tanstack/react-query';

export const useGetNotifications = (recipientAccountId: string, isRead: boolean) => {
  return useQuery({
    queryKey: ['notifications', recipientAccountId, isRead],
    queryFn: async () => GetNotificationsByRecipientAccountId(recipientAccountId, isRead)
  });
};
